import React, { useState, useEffect, useRef } from "react";
import makeStyles from "@mui/styles/makeStyles";
import {
  Grid,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Card,
  CardContent,
  FormHelperText,
} from "@mui/material";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers";



import { cellFocusEditor } from "../../../services/Common";

import { fr, enGB } from "date-fns/locale"; // import French and English locale

import "../common.css";

// react-tabulator
import "react-tabulator/lib/styles.css"; // required styles
import "react-tabulator/lib/css/tabulator.min.css"; // theme
import { ReactTabulator } from "react-tabulator";
import { useTranslation } from "react-i18next";
import encryptionService from "../../../services/encryptionService";

const OrderApprovalFormData = (props) => {
  const { t } = useTranslation();
  //get DispensingLanguage
  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage"),
  );
  const lan = localStorage.getItem("LangCode");
  const menukey = "order-approval";

  const tblRefHolder = useRef({ table: null });
  const tblRef = tblRefHolder.current;
  const classes = useStyles();

  const [manyTableData, setManyTableData] = useState([]);
  const [bCompleted, setbCompleted] = useState(false);
  const OrderType = JSON.parse(localStorage.getItem("OrderType"));
  //const OrderTo =JSON.parse(localStorage.getItem("FacilityList"));//JSON.parse(localStorage.getItem("OrderTo"));
  const UsersListByFacility = JSON.parse(
    localStorage.getItem("UsersListByFacility"),
  );
  const OrderListApprovalUser = JSON.parse(
    localStorage.getItem("OrderListApprovalUser"),
  );

  const UserInfo = encryptionService.decryptUserInfo();
  const UserId = UserInfo == 0 ? "" : UserInfo[0].id;

  //console.log("User Idssss",UserId);

  /*
if(props.formData.ApprovedBy>0){
  props.formData.formData["ApprovedBy"] = props.formData.ApprovedBy;
}else{
  props.formData.formData["ApprovedBy"] = UserId;
}

*/

  /* =====Start of Print Excel Many Code==== */
  const EXCEL_EXPORT_URL = process.env.REACT_APP_API_URL;

  const PrintMany = () => {
    let finalUrl =
      EXCEL_EXPORT_URL + "report/esigl_order_stock_entry_list_print.php";

    window.open(
      finalUrl +
        "?menukey=" +
        menukey +
        "&lan=" +
        localStorage.getItem("LangCode") +
        "&OrderId=" +
        props.formData.OrderId +
        "&TimeStamp=" +
        Date.now(),
    );
  };

  const ExcelMany = () => {
    let finalUrl =
      EXCEL_EXPORT_URL + "report/esigl_order_stock_entry_list_excel.php";

    window.open(
      finalUrl +
        "?menukey=" +
        menukey +
        "&lan=" +
        localStorage.getItem("LangCode") +
        "&OrderId=" +
        props.formData.OrderId +
        "&TimeStamp=" +
        Date.now(),
    );
  };
  /* =====End of Excel Export Code==== */

  const manycolumns = [
    { title: "Id", field: "id", visible: false },
    {
      title: t(DispensingLanguage[lan][menukey]["Sl#"]),
      width: 50,
      hozAlign: "center",
      formatter: "rownum",
      headerSort: false,
      headerHozAlign: "center",
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Product Code"]),
      field: "ItemCode",
      width: 120,
      headerFilter: true,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Product Name"]),
      field: "ItemName",
      headerFilter: true,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["AMC"]),
      field: "AMC",
      hozAlign: "right",
      headerHozAlign: "right",
      width: 65,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Min Qty"]),
      field: "MinQty",
      hozAlign: "right",
      headerHozAlign: "right",
      width: 60,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Max Qty"]),
      field: "MaxQty",
      hozAlign: "right",
      headerHozAlign: "right",
      width: 60,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Stock on Hand"]),
      field: "StockOnHand",
      width: 75,
      hozAlign: "right",
      headerHozAlign: "right",
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Calculated Order Quantity"]),
      field: "CalcOrderQty",
      width: 100,
      hozAlign: "right",
      headerHozAlign: "right",
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Submitted Order Quantity"]),
      field: "SubmittedOrderQty",
      width: 100,
      hozAlign: "right",
      headerHozAlign: "right",
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Actual Order Quantity"]),
      field: "ActualOrderQty",
      hozAlign: "right",
      headerHozAlign: "right",
      width: 100,
      editor: bCompleted === 0 ? cellFocusEditor : "",
      validator: ["integer", "min:0"],
      cssClass: "tabluator-column-editable",
      cellEdited: function (cell) {
        const curcellval = cell.getValue();
        const currow = cell.getRow();
        const rowdata = currow.getData();
        const pricecell = currow.getCell("LineTotal");
        const totprice = rowdata.UnitPrice * curcellval;
        pricecell.setValue(totprice);
        //props.setUpdatedDetailsGridDataHandler(currow._row.cells,false);
        //setUpdatedDetailsGridRowHandler(rowdata.id, curcellval, totprice);
      },
      formatter: function (cell, formatterParams) {
        const cellValue = cell.getValue();
        const rowData = cell.getRow().getData();
        const SubmittedOrderQty = rowData.SubmittedOrderQty;
        const Remarks = rowData.Remarks;

        if (
          SubmittedOrderQty != cellValue &&
          (Remarks == null || Remarks == "")
        ) {
          // cell.getRow().getElement().style.backgroundColor = "#ec7063";
        } else {
          // cell.getRow().getElement().style.backgroundColor = "transparent";
        }

        return cellValue;
      },
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Comment"]),
      field: "Remarks",
      width: 100,
      hozAlign: "left",
      headerHozAlign: "left",
      cssClass: "tabluator-column-editable text-field-editable",
      //  editor: bCompleted === 0? true : '',

      editor: bCompleted === 0 ? cellFocusEditor : "",

      formatter: function (cell, formatterParams) {
        const cellValue = cell.getValue();
        const rowData = cell.getRow().getData();
        const SubmittedOrderQty = rowData.SubmittedOrderQty;
        const ActualOrderQty = rowData.ActualOrderQty;

        if (
          SubmittedOrderQty != ActualOrderQty &&
          (cellValue == null || cellValue == "")
        ) {
          // cell.getRow().getElement().style.backgroundColor = "#ec7063";
        } else {
          // cell.getRow().getElement().style.backgroundColor = "transparent";
        }

        return cellValue;
      },
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Unit Price"]),
      field: "UnitPrice",
      hozAlign: "right",
      headerHozAlign: "right",
      width: 90,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Line Total"]),
      field: "LineTotal",
      formatter: "money",
      hozAlign: "right",
      bottomCalc: "sum",
      bottomCalcFormatter: "money",
      headerHozAlign: "right",
      width: 105,
    },
  ];

  const ManyDataItems = props.ManyTableData?.map((item, index) => {
    item["LineTotal"] = item.ActualOrderQty * item.UnitPrice;
    return item;
  });

  useEffect(() => {
    if (props.bFirst) {
      setManyTableData(props.ManyTableData);
    }
    setbCompleted(props.bCompleted);
  }, [props.ManyTableData, props.bCompleted]);

  return (
    <div className={classes.productPageTitle}>
      <div className="sw_makeStyles_tableContainer">
        <div className="d-flex justify-product mb-3">
          <Grid container>
            <Grid item xs={12} sm={12}>
              <div className="sw_page_heading">
                <div className="sw_heading_title">
                  {DispensingLanguage[lan][menukey]["Order - Add/Edit"]}
                </div>

                <div className="float-end sw_btn_control">
                  {/* Action buttons */}
                  {props.addProductForm ? (
                    <Grid item xs={12} className="mt-4 text-center">
                      <Button
                        className="me-2"
                        variant="contained"
                        color="gray"
                        type="reset"
                        onClick={() => props.handleReset()}
                      >
                        {DispensingLanguage[lan][menukey]["Reset"]}
                      </Button>
                      <Button
                        className="me-2"
                        variant="contained"
                        color="primary"
                        disabled={!!props.isSubmitting}
                        onClick={() => {
                          if (props.isSubmitting) return;
                          props.handleSubmit();
                        }}
                      >
                        {DispensingLanguage[lan][menukey]["Save"]}
                      </Button>
                      <Button
                        className="me-2"
                        variant="contained"
                        color="gray"
                        type="reset"
                        onClick={() => props.history.push("/order-approval")}
                      >
                        {DispensingLanguage[lan][menukey]["Back to List"]}
                      </Button>
                    </Grid>
                  ) : (
                    <Grid item xs={12} className="mt-2 text-center">
                      <Button
                        className="me-2"
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          if (props.isSubmitting) return;
                          props.handleUpdate();
                        }}
                        disabled={bCompleted === 1 || !!props.isSubmitting}
                      >
                        {DispensingLanguage[lan][menukey]["update"]}
                      </Button>

                      <Button
                        className="me-2"
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          if (props.isSubmitting) return;
                          props.handlePost();
                        }}
                        disabled={bCompleted === 1 || !!props.isSubmitting}
                      >
                        {DispensingLanguage[lan][menukey]["post"]}
                      </Button>

                      <Button
                        className="me-2"
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          if (props.isSubmitting) return;
                          props.handleReject();
                        }}
                        disabled={bCompleted === 1 || !!props.isSubmitting}
                      >
                        {DispensingLanguage[lan][menukey]["reject"]}
                      </Button>

                      <Button
                        className="me-2"
                        variant="contained"
                        color="gray"
                        type="reset"
                        //onClick={event =>  window.location.href='/order'}
                        onClick={() => props.history.push("/order-approval")}
                      >
                        {DispensingLanguage[lan][menukey]["Back to List"]}
                      </Button>

                      <Button
                        variant="contained"
                        color="primary"
                        className="me-2 sw_icons"
                        onClick={() => PrintMany()}
                      >
                        <i className="fas fa-print"></i>
                      </Button>

                      <Button
                        variant="contained"
                        color="primary"
                        className="me-2 sw_icons"
                        onClick={() => ExcelMany()}
                      >
                        <i className="far fa-file-excel"></i>
                      </Button>
                    </Grid>
                  )}
                  {/* End Action buttons */}
                </div>
              </div>
            </Grid>
          </Grid>
        </div>

        <Grid container spacing={3} className="mb-3">
          <Grid item xs={3} sm={3}>
            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={lan === "en_GB" ? enGB : fr}>
                            <DatePicker
                  label={DispensingLanguage[lan][menukey]["Order Date"]}
                  //disableToolbar
                  value={props.formData.OrderDate || props.selectedDate}
                  inputFormat="dd/MM/yyyy"
                  onChange={(e) => props.handleRDateChange(e, "OrderDate")}
                  disabled={true}
                                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    error={!!props.errorObject.OrderDate}
                    helperText={props.errorObject.OrderDate}
                    className={classes.fullWidth}
                    id="OrderDate"
                    name="OrderDate"
                    fullWidth
                  />
                )}
              />
            </LocalizationProvider>
          </Grid>

          <Grid item xs={3} sm={3}>
            <TextField
              variant="standard"
              error={!!props.errorObject.OrderNo}
              helperText={props.errorObject.OrderNo}
              required
              id="OrderNo"
              name="OrderNo"
              label={DispensingLanguage[lan][menukey]["Order No"]}
              value={props.formData.OrderNo || props.generatedInvoiceNo}
              fullWidth
              autoComplete="family-name"
              onChange={(e) => props.handleChange(e)}
              disabled={true}
            />
          </Grid>
          <Grid item xs={3} sm={3}>
            <FormControl variant="standard" className={classes.fullWidth}>
              <InputLabel id="demo-simple-select-helper-label">
                {DispensingLanguage[lan][menukey]["Order Type"]}
              </InputLabel>
              <Select
                error={!!props.errorObject.OrderTypeId}
                required
                labelId="demo-simple-select-helper-label"
                id="OrderTypeId"
                name="OrderTypeId"
                value={props.formData.OrderTypeId}
                fullWidth
                onChange={(e) => props.handleChange(e)}
                disabled={true}
                //disabled={bCompleted===1}
                label={DispensingLanguage[lan][menukey]["Order Type"]}
              >
                {OrderType.map((item, index) => {
                  return (
                    <MenuItem key={item.id} value={item.id}>
                      {item.name}
                    </MenuItem>
                  );
                })}
              </Select>
              <FormHelperText error={!!props.errorObject.OrderTypeId}>
                {props.errorObject.OrderTypeId}
              </FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={3} sm={3}>
            <TextField
              variant="standard"
              error={!!props.errorObject.OrderingFrom}
              helperText={props.errorObject.OrderingFrom}
              required
              id="OrderingFrom"
              name="OrderingFrom"
              label={DispensingLanguage[lan][menukey]["Order To"]}
              value={props.formData.OrderingFromText}
              fullWidth
              autoComplete="family-name"
              onChange={(e) => props.handleChange(e)}
              disabled={true}
            />
          </Grid>

          <Grid item xs={3} sm={3}>
            <FormControl variant="standard" className={classes.fullWidth}>
              <InputLabel id="demo-simple-select-helper-label">
                {DispensingLanguage[lan][menukey]["Entry By"]}
              </InputLabel>
              <Select
                error={!!props.errorObject.OrderBy}
                // helperText={props.errorObject.OrderBy}
                required
                labelId="demo-simple-select-helper-label"
                id="OrderBy"
                name="OrderBy"
                value={props.formData.OrderBy}
                fullWidth
                onChange={(e) => props.handleChange(e)}
                disabled={true}
                //disabled={bCompleted===1}
                label={DispensingLanguage[lan][menukey]["Entry By"]}
              >
                {OrderListApprovalUser.map((item, index) => {
                  return (
                    <MenuItem key={item.id} value={item.id}>
                      {item.name}
                    </MenuItem>
                  );
                })}
              </Select>

              <FormHelperText error={!!props.errorObject.OrderBy}>
                {props.errorObject.OrderBy}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={3} sm={3}>
            <FormControl variant="standard" className={classes.fullWidth}>
              <InputLabel id="demo-simple-select-helper-label">
                {DispensingLanguage[lan][menukey]["InternalApprover"]}
              </InputLabel>
              <Select
                error={!!props.errorObject.InternalApprover}
                labelId="demo-simple-select-helper-label"
                id="InternalApprover"
                name="InternalApprover"
                value={props.formData.InternalApprover}
                fullWidth
                onChange={(e) => props.handleChange(e)}
                disabled={true}
                label={DispensingLanguage[lan][menukey]["InternalApprover"]}
              >
                {OrderListApprovalUser.map((item, index) => {
                  return (
                    <MenuItem key={item.id} value={item.id}>
                      {item.name}
                    </MenuItem>
                  );
                })}
              </Select>
              <FormHelperText error={!!props.errorObject.InternalApprover}>
                {props.errorObject.InternalApprover}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={3} sm={3}>
            <FormControl variant="standard" className={classes.fullWidth}>
              <InputLabel id="demo-simple-select-helper-label">
                {DispensingLanguage[lan][menukey]["Approved By"]}
              </InputLabel>
              <Select
                error={!!props.errorObject.ApprovedBy}
                // helperText={props.errorObject.ApprovedBy}
                required
                labelId="demo-simple-select-helper-label"
                id="ApprovedBy"
                name="ApprovedBy"
                value={
                  props.formData.ApprovedBy > 0
                    ? props.formData.ApprovedBy
                    : UserId
                }
                fullWidth
                onChange={(e) => props.handleChange(e)}
                //disabled={true}
                disabled={bCompleted === 1}
                label={DispensingLanguage[lan][menukey]["Approved By"]}
              >
                {OrderListApprovalUser.map((item, index) => {
                  return (
                    <MenuItem key={item.id} value={item.id}>
                      {item.name}
                    </MenuItem>
                  );
                })}
              </Select>

              <FormHelperText error={!!props.errorObject.ApprovedBy}>
                {props.errorObject.ApprovedBy}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={3} sm={3}>
            <TextField
              variant="standard"
              id="FacilityId"
              name="FacilityId"
              label="FacilityId"
              value={props.formData.FacilityId}
              fullWidth
              hidden
              autoComplete="family-name"
            />
            <TextField
              variant="standard"
              id="OrderId"
              name="OrderId"
              label="OrderId"
              value={props.formData.OrderId || ""}
              fullWidth
              hidden
              autoComplete="family-name"
            />
          </Grid>
        </Grid>

        <Grid container spacing={3}>
          {/* new row */}
          <Grid item xs={12} sm={12}>
            <Card className="sw_card">
              <CardContent>
                <div>
                  <div className="uniqueName">
                    <ReactTabulator
                      onRef={(r) => {
                        tblRef.table = r.current;
                      }}
                      columns={manycolumns}
                      data={manyTableData}
                      layout={"fitColumns"}
                      height="340px"
                    />
                  </div>
                </div>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default OrderApprovalFormData;

const useStyles = makeStyles({
  productPageTitle: {
    marginTop: "60px",
    color: "white",
    padding: "10px",
  },
  tableContainer: {
    backgroundColor: "whitesmoke",
    borderRadius: "10px",
    padding: "2rem",
    color: "black",
  },
  fullWidth: {
    width: "100%",
  },
});
